import router from "@/router";
import mobile from '@/utils/mobile';
import {
	mapState
} from "vuex";

import moment from "moment";

export default {
	data() {
		return {
			API_LINK: process.env.NODE_ENV !== "production" ? process.env.VUE_APP_API_ROOT :
			'', //全局资源路径 导出使用  例如 let url = this.API_LINK + '/api/giftEmpList'
		};
	},
	computed: {
		mobile_view() { return mobile.active; },
		...mapState(['vuex_region_list','vux_case_type','vux_case_type2','vuex_custom_type_list']),
		mix_user_avatar() {
			return this.vuex_user.image || ''
		}
	},
	watch: {

	},
	filters: {

	},
	methods: {
		//案源分类多个
		minx_get_causeIds(ids){
			let id_list=ids.split(',')
			let text_list=[]
			let text=''
			this.vux_case_type2.forEach((e)=>{
				id_list.forEach((v)=>{
					if(v==e.id){
						text_list.push(e.title)
					}
				})
			})
			// console.log('text',text_list)
			text=text_list.join(',')
			return text
		},
		//省市区获取
		minx_get_province_cita_area(id1,id2,id3){
			let texts=[]
			console.log('vuex_region_list',this.vuex_region_list)
			this.vuex_region_list.forEach((e1) => {
				if(e1.id==id1){
					texts.push(e1.name)
					e1.children.forEach((e2)=>{
						if(e2.id==id2){
							texts.push(e2.name)
							e2.children.forEach((e3)=>{
								if(e3.id==id3){
									texts.push(e3.name)
								}
							})
						}
					})
				}
			})
			return texts.join('-')
		},

		//获取省
		minx_get_province(id){
			let texts=''
			this.vuex_region_list.forEach((e) => {
				if(e.id==id){
					texts=e.name
				}
			})
			return texts
		},
		//案件类型
		minx_get_case_type(id){
			let texts=''
			console.log('vux_case_type',this.vux_case_type)
			this.vux_case_type.forEach((e) => {
				if(e.id==id){
					texts=e.name
				}
			})
			return texts
		},
		//自然人法人其它组织
		minx_get_custom_type(id){
			let texts=''
			console.log('vuex_custom_type_list',this.vuex_custom_type_list)
			this.vuex_custom_type_list.forEach((e) => {
				if(e.value==id){
					texts=e.title
				}
			})
			return texts
		},
		$log(text, data) {
			if (typeof data == 'object') {
				try {
					data = JSON.parse(JSON.stringify(data))
				} catch (e) {
					console.error('logjson 异常', e)
				}
			}
			console.warn('logjson => ', text, ' => ', data);
		}
	}
};
